import React, { memo } from 'react'
import { AnyStyledComponent } from 'styled-components'

import {
    IconImage,
    WishlistCount,
    WishlistIconContainer,
    WishlistIconWrapper,
    WishlistText,
} from './header-section-styles'
import { HeaderSectionTransport } from './../../../transports/region-landing-page-transport'
import HeartWishlistIcon from '../../../assets/icons/object-icons/heart.svg'

type Navigation = HeaderSectionTransport['navigationSectionResponse']['navigation']

interface WishlistButtonProps {
    wishlistButton: Navigation['wishlistButton']
    wishlistCount?: number | null
    onClick: React.MouseEventHandler<HTMLAnchorElement>
}

const WishlistButton: React.FC<WishlistButtonProps> = ({ wishlistButton, wishlistCount, onClick }) => {
    if (!wishlistButton?.url) {
        return null
    }

    return (
        <WishlistIconWrapper href={wishlistButton.url} onClick={onClick} noCrawl={wishlistButton.noCrawl}>
            <WishlistIconContainer hasCount={!!wishlistCount}>
                <IconImage as={HeartWishlistIcon as AnyStyledComponent} />
                {wishlistCount && <WishlistCount>{wishlistCount}</WishlistCount>}
            </WishlistIconContainer>
            <WishlistText>{wishlistButton.text}</WishlistText>
        </WishlistIconWrapper>
    )
}

export default memo(WishlistButton)
